<template>
  <div class="border-b-sm border-border-tertiary">
    <div class="p-16 md:p-24">
      <h2 class="heading-xs mb-8">Familjeabonnemang</h2>
      <p>{{ subTitle }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  subTitle: string;
}
defineProps<Props>();
</script>

<style scoped></style>
